import Box from '@mui/material/Box';
import LazyEditorV2Sidebar from '../../components/editorV2Siderbar/lazyEditorV2Sidebar.jsx';

export default function LazyNewV1Endpoint(_props) {
  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <LazyEditorV2Sidebar />
      <Box
        component="main"
        sx={{ flexGrow: 1, height: '100%', backgroundColor: '#1e1e1e' }}
      ></Box>
    </Box>
  );
}
